export function classConfig() {
  return {
    id: Math.random(),
    flags: {
      after: {
        factory: false
      },
      before: {
        factory: false
      }
    },
    ignore: {
      args: [],
      Class: [
        "afterFactory",
        "afterFactoryOnce",
        "beforeFactory",
        "beforeFactoryOnce",
        "constructor",
        "factory",
        "industry"
      ],
      instance: [
        "afterFactory",
        "afterInit",
        "beforeInit",
        "Class",
        "constructor",
        "industry"
      ]
    }
  }
}

export function instanceConfig() {
  return {
    flags: {
      init: false
    }
  }
}
